//Custom.ts =================================================
import "./Util/Prototypes";

import * as Carousel from "./Util/Carousel";
import * as CommunityInfo from "./Widgets/CommunityInfo";
import * as DataTable from "./Util/DataTable";
import * as DrawerMenu from "./Menus/DrawerMenu";
import * as MainMap from "./MainMap";
import * as Search from "./Search/Search";
import * as Settings from "./Settings";
import * as Util from "./Util/Util";
import * as Util_App from "./Util/Util_App";

import AttachmentInfo from "@arcgis/core/rest/query/support/AttachmentInfo";
import AttachmentQuery from "@arcgis/core/rest/support/AttachmentQuery";
import Graphic from "@arcgis/core/Graphic";
import Point from "@arcgis/core/geometry/Point";
import WMTSSublayer from "@arcgis/core/layers/support/WMTSSublayer";

//Set custom hyperlink at the top of the results list.
export function getCustomLinks(layerName: string, feature: Graphic, fs: __esri.FeatureSet) {
   const vals: string[] = [];
   const urls: string[] = [];
   if (!feature) {
      return { values: vals, urls: urls };
   }

   const fields: __esri.Field[] = fs.fields;
   const atrs: any = feature.attributes;
   let title: string = "";
   let popupSpec: Settings.iPopUpTable;
   let url: string;
   let links: string;
   let fsLinks: string[];
   let pin: string;

   //Get mbr.
   let mbr: __esri.Extent;
   if (feature.geometry && feature.geometry.extent) {
      mbr = feature.geometry.extent;
   }

   //Parcels.
   if (layerName === "Parcels") {
      pin = Util_App.getFieldValueNoCase("PIN", feature, fs) as string;

      let centerPnt: __esri.Point;
      if (mbr) {
         centerPnt = Util_App.getPointInsidePolygon(feature.geometry as __esri.Polygon);
      }

      //CAMA report.
      if (Settings.security.accessLevel >= 7) {
         vals.Add("CAMA Report");
         url = Settings.webServerURL + "/CompReport/Default.aspx?pin=" + pin;
         urls.Add(url);
      }

      //Property report.
      vals.Add("Property Report");
      url = Settings.webServerURL + "/Property_Report_TS/Default.aspx?pin=" + pin + "&isTinyScreen=" + false;
      urls.Add(url);

      //Sales history.
      //if (Settings.security.accessLevel >= 1) {
      //   title = "Sales History";
      //   popupSpec = Util_App.getDataTableSpec(title);

      //   if (popupSpec) {
      //      vals.Add(title);
      //      url = "js:showDataTable|" + title + "," + pin;
      //      urls.Add(url);
      //   }
      //}

      ////Tax history.
      //title = "Tax History";
      //popupSpec = Util_App.getDataTableSpec(title);

      //if (popupSpec) {
      //   vals.Add(title);
      //   url = "js:showDataTable|" + title + "," + pin;
      //   urls.Add(url);
      //}

      ////Building permits and code violations.
      //vals.Add("Building Permits");
      //url = Settings.webServerURL + "/permits/?pin=" + pin;
      //urls.Add(url);

      ////Tax Estimator.
      //vals.Add("Tax Estimator");
      //url = Settings.webServerURL + "/TaxEstimator/?pin=" + pin;
      //urls.Add(url);

      //Pictures and sketches.
      if (Settings.security.accessLevel >= 1) {
         links = Util_App.getFieldValueNoCase("PictureLinks", feature, fs);
         fsLinks = addToLinks(links, fsLinks);

         links = Util_App.getFieldValueNoCase("SketchLinks", feature, fs);
         fsLinks = addToLinks(links, fsLinks);

         links = fsLinks.join(",");

         if (fsLinks.length > 0) {
            vals.Add("Photos/Sketches");
            url = "js:showCarousel|" + links;
            urls.Add(url);
         }
      }

   } //End if layername parcels.

   if (vals.length !== urls.length) {
      alert("Error: The number of custom links does not match the number of custom values");
   }
   return { values: vals, urls: urls };
}

//Set custom field value in the results list.
export function getCustomValueFeature(fieldName: string, fieldValue: any, feature: Graphic, layerName: string, fs: __esri.FeatureSet) {
   //let pin: string;
   let outVal: any = fieldValue;
   let url = "";
   let txt: string;
   let pins: string[];

   if (fieldName.Equal("Deed")) {
      url = Util_App.getFieldValueNoCase("DeedLink", feature, fs) as string;

      if (url) {
         url = Settings.webServerURL + url;
      } else {
         outVal = "Not available";
      }

   } else if (fieldName.Equal("Plat")) {
      url = Util_App.getFieldValueNoCase("PlatLink", feature, fs) as string;

      if (url) {
         url = Settings.webServerURL + url;
      } else {
         outVal = "Not available";
      }

      //Create links on comp pins. !!!
   } else if (fieldName.Equal("CompPINs")) {
      //pins = fieldValue.split(",");

      //outVal = "";

      //for (const compPIN of pins) {
      //   outVal += compPIN;
      //   url = "js:zoomTo|" + links;
      //   urls.Add(url);
      //}

      //Price per square feet.
   } else if (fieldName.Equal("TAXPARCELTYPE")) {
      const totImp: number = Util_App.getFieldValueNoCase("TotalImprovementsValue", feature, fs);
      const sqFt: number = Util_App.getFieldValueNoCase("SqFt", feature, fs);

      outVal = "0";

      if (sqFt > 0 && totImp > 0) {
         outVal = (totImp / sqFt).toString();
         outVal = Util.formatTextValue(outVal, "Money");
      }

      //Fema loma link.
   } else if (fieldName.Equal("FEMA_LOMA_Link")) {
      url = Util_App.getFieldValueNoCase("FEMA_LOMA_Link", feature, fs) as string;

      if (url) {
         outVal = "Yes";
      } else {
         outVal = "No";
      }

      //Decode subtypes.
   } else if (fieldName.Equal("StreetClass")) {
      if (fieldValue === 4) {
         outVal = "Secondary";
      }

   } else if (fieldName.Equal("PropUseCode") || fieldName.Equal("PropUseCode_Sales")) {
      url = Settings.webServerURL + "/WebsiteData/Assessor/PropUseCode.pdf";

   } else if (fieldName.Equal("DatePaid")) {
      const status: string = Util_App.getFieldValueNoCase("Status", feature, fs);
      if (status === "Not Paid") {
         outVal = "";

      } else {
         if (outVal !== "") {
            if ((outVal.Contains("/2049")) || (outVal.Contains("/2050"))) {
               outVal = "";
            }
         }
      }

   } else if (fieldName.Equal("LandUse")) {
      url = Settings.webServerURL + "/WebsiteData/ZoningCodePDF/Future_Land_Use/519_9 - Land Use Element 2010.pdf";

   } else if (fieldName.Equal("IMS_Label")) {
      if (fieldValue.StartsWith("PD-")) {
         outVal = "PDD";

      } else if (fieldValue !== "") {
         url = Settings.webServerURL + "/WebsiteData/ZoningCodePDF/Zoning_Fact_Sheets/" + fieldValue + ".pdf";
      }

   } else if (fieldName.Equal("OrdinanceNum")) {
      txt = Util_App.getFieldValueNoCase("IMS_Label", feature, fs);

      if (txt.StartsWith("PD-")) {
         url = Settings.webServerURL + "/WebsiteData/ZoningCodePDF/PDD_Ordinances/" + fieldValue + ".pdf";

      } else if (txt !== "") {
         url = Settings.webServerURL + "/WebsiteData/ZoningCodePDF/Zoning_Ordinances/" + txt + ".pdf";
      }
   }

   return { value: outVal, url: url };
}

//Set custom visibility for field names in point feature layer labels.
export function getCustomLabelFieldNameVisibility(layerName: string, fieldName: string): boolean {
   let visible: boolean = true;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   //if (fieldName.Equal("Scale")) {
   //   if (mapScale < 0) {
   //      visible = false;
   //   }

   //} else if (fieldName.Equal("OtherField")) {
   //}

   return visible;
}

//Set custom angle for point graphic symbol labels.
export function getCustomLabelAngle(layerName: string, angle: number): number {
   let outAngle: number = angle;
   //outAngle = -angle;
   return outAngle;
}

//Set custom Arcade formatting expression for point feature class labels.
export function getCustomLabelFormatExpression(layerName: string): string {
   let expression: string = null;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   if (layerName.Equal("Place Names")) {
      if (mapScale < 0) {
         //IIF($feature.POPULATION > 10000, $feature.NAME + ' city', $feature.NAME + ' town')
         //expression = "'Address: ' + $feature.fieldName1 + TextFormatting.NewLine + $feature.fieldName2";
         //expression = "'Address: ' + $feature.scale";
      }

   } else if (layerName.Equal("OtherField")) {

   }

   return expression;
}

//Set custom sql where string for feature layer labels.
export function getCustomLabelQuery(layerName: string): string {
   let sql: string = null;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   //if (layerName.Equal("Place Names")) {
   //   if (mapScale < 0) {
   //      sql = "scale = 800";
   //   }

   //} else if (layerName.Equal("OtherField")) {
   //}

   return sql;
}

//Set custom visiblity for line and polygon feature layer label values.
export function getCustomLabelVisibility(fieldName: string, fieldValue: any, feature: Graphic, layerName: string, fs: __esri.FeatureSet): boolean {
   let visible: boolean = true;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   if (fieldName.Equal("BlaBla")) {
      const totalValue = Util_App.getFieldValueNoCase("totalValue", feature, fs) as number;
      if (totalValue < 300000 && mapScale < 400) {
         visible = false;
      }

   } else if (fieldName.Equal("OtherField")) {
   }

   return visible;
}

//Set custom text value for line and polygon feature layer label values.
export function getCustomLabelValue(fieldName: string, fieldValue: any, feature: Graphic, layerName: string, fs: __esri.FeatureSet): string {

   //if (fieldName.Equal("pin")) {
   //   fieldValue += " ac";

   //} else if (fieldName.Equal("OtherField")) {
   //}

   return fieldValue as string;
}

//Set custom no value text for community info.
export function getCustomNoValueText(description: string): string {
   let outVal: string = "Not available";

   if (description.Equal("Bla Bla")) {
      outVal = "Bla Bla";
   }

   return outVal;
}

//Set custom map tip title html.
export function getCustomMapTipTitleHTML(layerName: string, feature: Graphic, fs: __esri.FeatureSet): string {
   let html: string = "";
   let pin: string;

   //Parcels.
   if (layerName === "Parcels") {
      pin = Util_App.getFieldValueNoCase("PIN", feature, fs) as string;
      html += '<span style="color: darkred; margin-left: 9px;">' + pin + '</span> ';

   } //End if layername parcels.
   return html;
}

//Set custom map tip content html.
export function getCustomMapTipContentHTML(layerName: string, feature: Graphic, fs: __esri.FeatureSet): string {
   let html: string = "";

   //Parcels.
   if (layerName === "Parcels") {

      let siteAddress: string = Util_App.getFieldValueNoCase("SiteAddress", feature, fs);
      siteAddress = Util.formatTextValue(siteAddress, "MixedCase");

      const beds: number = Util_App.getFieldValueNoCase("Bedrooms", feature, fs);
      const baths: number = Util_App.getFieldValueNoCase("Bathrooms", feature, fs);
      let sqFt: any = Util_App.getFieldValueNoCase("SqFt", feature, fs);
      sqFt = Util.formatTextValue(sqFt, "Comma");

      let mrkLand: any = Util_App.getFieldValueNoCase("MarketValue_Land", feature, fs);
      let mrkImp: any = Util_App.getFieldValueNoCase("MarketValue_Improvement", feature, fs);
      let mrkTotal: any = Util_App.getFieldValueNoCase("MarketValue_Total", feature, fs);

      mrkLand = Util.formatTextValue(mrkLand, "Comma");
      mrkImp = Util.formatTextValue(mrkImp, "Comma");
      mrkTotal = Util.formatTextValue(mrkTotal, "Comma");

      html += 'Market Land: <span style="color: black; font-weight: bold;">&nbsp;' + mrkLand + '</span>&nbsp;';
      html += 'Imp: <span style="color: black; font-weight: bold;">&nbsp;' + mrkImp + '</span>&nbsp;';
      html += 'Tot: <span style="color: black; font-weight: bold;">&nbsp;' + mrkTotal + '</span>';
      html += '<br />';

      html += '<span style="color: darkred; font-weight: bold;">' + beds + '</span>&nbsp;Beds&nbsp;';
      html += '<span style="color: darkred; font-weight: bold;">' + baths + '</span>&nbsp;Baths&nbsp;';
      html += '<span style="color: darkred; font-weight: bold;">' + sqFt + '</span>&nbsp;SqFt&nbsp;&nbsp;&nbsp;';

      html += '<span style="color: green; font-weight: bold;">' + siteAddress + '</span>';

      if (Settings.security.accessLevel >= 1) {
         let fsLinks: string[];

         let links: string = Util_App.getFieldValueNoCase("PictureLinks", feature, fs);
         fsLinks = addToLinks(links, fsLinks);

         links = Util_App.getFieldValueNoCase("SketchLinks", feature, fs);
         fsLinks = addToLinks(links, fsLinks);

         for (const url of fsLinks) {
            html += '<img width="' + Settings.leftPanelWidth + '" alt="Picture" src="' + url + '" />';
         }
      }

   } //End if layername parcels.

   return html;
}

//Initialize custom layer properties.
export function setLayerProps(layer: any) {
   let sym: any;

   if (layer.id.Equal("Scene Layer Name Here")) {
      sym = {
         type: "mesh-3d",
         symbolLayers: [{
            type: "fill",
            material: { color: "green" },
         }],
      };

      layer.renderer = { type: "simple", symbol: sym, };

   } else if (layer.id.Equal("Polygon Layer Name Here")) {
      sym = { type: "simple-fill", color: [255, 255, 255, 0.2], style: "solid", outline: { color: [0, 180, 255, 1], width: 2 } };
      layer.renderer = { type: "simple", symbol: sym, };

   } else if (layer.id.Equal("Line Layer Name Here")) {
      sym = { type: "simple-line", color: [255, 16, 19, 0.5], width: 5 };
      layer.renderer = { type: "simple", symbol: sym, };

   } else if (layer.id.Equal("2014 Aerial Photos")) {
      const wmtsLayer = layer as __esri.WMTSLayer;
      wmtsLayer.activeLayer = new WMTSSublayer({ id: "PICT-OHHOLM14-io4IHWb2CE" });
      // { id: "PICT-OHCARR23-p7KCposBYL", tileMatrixSetId: "GoogleMapsCompatible" };
   }
}

//Call custom javascript functions.
export function callFunction(js: string) {
   const sa: string[] = js.replace("js:", "").split("|");
   let sa2: string[];
   const name: string = sa[0].trim();
   let oid: number;
   let layerName: string;
   let featureLayer: __esri.FeatureLayer;
   let attachment: AttachmentInfo;
   let attachments: AttachmentInfo;
   let url: string;

   if (name === "showCarousel") {
      if (sa.length > 1) {
         const urls: string[] = sa[1].split(",");
         Carousel.show("Photos and Sketches", urls, 400);
      }

   } else if (name === "showDataTable") {
      if (sa.length > 1) {
         sa2 = sa[1].split(",");
         const title: string = sa2[0].trim();
         const id: string = sa2[1].trim();
         DataTable.show(title, id);
      }

   } else if (name === "showCommunityInfo") {
      if (sa.length > 1) {
         const xy: string[] = sa[1].split(",");
         const x: number = Util.parseFlt(xy[0]);
         const y: number = Util.parseFlt(xy[1]);
         CommunityInfo.setCenterPnt(new Point({ x: x, y: y, spatialReference: MainMap.activeView.spatialReference }));
         DrawerMenu.showTool("Community Information");
      }

   } else if (name === "showSalesSearch") {
      if (sa.length > 1) {
         Search.setActivePIN(sa[1].trim());
         DrawerMenu.showTool("Sales Search");
      }

   } else if (name === "zoomTo") { //!!!
      if (sa.length > 1) {
         MainMap.activeView.goTo(34);
      }

   } else if (name === "showAttachment") {
      if (sa.length > 1) {
         sa2 = sa[1].split(",");
         layerName = sa2[0].trim();
         oid = Util.parseInteger(sa2[1]);

         featureLayer = Util_App.getLayerById(layerName) as __esri.FeatureLayer;

         if (featureLayer && featureLayer.capabilities.attachment && featureLayer.capabilities.attachment.supportsName) {
            const attachmentQuery = new AttachmentQuery( { objectIds: [oid] });

            featureLayer.queryAttachments(attachmentQuery).then(function (attachments: __esri.AttachmentInfo) {
               if (attachments[oid]) {
                  attachment = attachments[oid][0];
                  url = attachment.url + "/" + attachment.name;
                  window.open(url, "Attachment");
               }

            }).catch(function (error: Error) {
               console.log("attachment query error", error);
            });
         }
      }

   }
}

//Get links.
export function addToLinks(links: string, inLinks: string[]): string[] {
   let url: string;
   let outLinks: string[] = inLinks;

   if (!outLinks) {
      outLinks = [];
   }
   if (links && (links !== "")) {
      const sa: string[] = links.split(",");

      for (const txt of sa) {
         url = Settings.webServerURL + txt;
         outLinks.Add(url);
      }
   }
   return outLinks;
}

//Add dashes to PIN.
export function addDashesToPIN(pin: string): string {
   let i: number = 0;
   let c: string;
   let isNumber: boolean = true;
   let outPIN: string = pin;

   if ((pin.length === 10) && (!pin.Contains("-"))) {
      for (i = 0; i < pin.length; i++) {
         c = pin.charAt(i);
         if (!c.IsNumeric()) {
            isNumber = false;
            break;
         }
      }
      if (isNumber) {
         outPIN = pin.SubStr(0, 4) + "-";
         outPIN += pin.SubStr(4, 3) + "-";
         outPIN += pin.SubStr(7, 3);
      }
   }
   return outPIN;
}

//Open a custom link.
export function openLink(toolName: string) {
   let url: string;

   if (toolName === "Contact Us") {
      url = "https://www.google.com";
      window.open(url, "ContactUs");

   } else if (toolName === "Home") {
      url = "https://www.greenwoodcounty-sc.gov";
      window.open(url, "Home");

   } else if (toolName === "Privacy Policy") {
      window.open(url, "PrivacyPolicy");
   }
}
